import axios from "axios";

export default {
    methods: {
        getEmployeeId() {
            return new Promise( (resolve, reject) => {
                return axios.post(
                    '/api/?entity=vessel&action=getVessel'
                ).then( (response) => {
                    if( typeof response.data !== 'undefined' &&
                        typeof response.data.employees !== 'undefined' &&
                        typeof response.data.employees.data !== 'undefined'
                    ) {
                        resolve(response.data.employees.data[0].id);
                    } else {
                        reject('Employee is undefined. Error fetching employee notifications.');
                    }
                }).catch( (error) => {
                    reject(error);
                });
            });
        },
        stripSlashes(str) {
            return str.replace(/\\/g, '');
        },
        escapeHtml(str) {
            return str
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#039;");
        }
    }
}